import { AbstractControl, FormArray, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators } from "@angular/forms";
import { Expert } from "./expert.schema";

export class ExpertDeliveryRulesSchema {
    public static validation(): { [key: string]: AbstractControl } {
        let validator: { [key: string]: AbstractControl } = {
            expert: new FormGroup({ id: new FormControl('', Validators.required) }),
            operator: new FormControl(''),
            rules: new FormArray(
                [ExpertRules.createFormGroup()],
                [ExpertDeliveryRulesSchema.uniqueOperatorsValidator()]
            ),
            associateExpertWithRule: new FormArray([new FormGroup(AssociateExpertWithRule.validation())]),
        }

        return validator;
    }

    public static associateExpertWithDeliveryRuleFormGroup() {
        return new FormGroup(AssociateExpertWithRule.validation());
    }

    static uniqueOperatorsValidator(): ValidatorFn {
        return (formArray: AbstractControl): ValidationErrors | null => {
            const controls = (formArray as FormArray).controls;
            const seen = new Set<string>();
            for (let ctrl of controls) {
                const operator = ctrl.get('operator')?.value;
                if (seen.has(operator)) {
                    return { duplicateOperator: true };
                }
                seen.add(operator);
            }
            return null;
        };
    }
    

    public static readonly validationMessages = {
        'expert': {
            'id': [{ type: 'required', message: 'Obbligatorio' }]
        },
        'rules': {
            'operator': [
              { type: 'required', message: 'Operatore obbligatorio' }
            ],
            'pickUps': [
              { type: 'required', message: 'Obbligatorio' },
              { type: 'pattern', message: 'Deve essere un numero' }
            ],
            'plusSalary': [
                { type: 'required', message: 'Obbligatorio' },
                { type: 'pattern', message: 'Deve essere un numero valido' }
            ],
            'duplicateOperator': 'Non puoi aggiungere più regole con lo stesso operatore.'
        }
    }

    constructor(
        public id?: number,
        public expert?: Expert,
        public pickUps?: number,
        public operator?: string,
        public rules?: any,
        public associateExpertWithRule?: any,
    ){}

}

export class ExpertRules {

    public static createFormGroup(): FormGroup {
        return new FormGroup({
            operator: new FormControl('equal', Validators.required),
            pickUps: new FormControl('', [Validators.required, Validators.pattern('^[0-9]*$')]),
            plusSalary: new FormControl(0, [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/)]),
        });
    }

    constructor() { }
}

export class AssociateExpertWithRule {
    public static validation(): { [key: string]: AbstractControl } {
        let validator: { [key: string]: AbstractControl } = {
            expert: this.associateExpertWithRuleFormGroup(),
        };
        return validator;
    }

    public static associateExpertWithRuleFormGroup() {
        return new FormGroup({
            id: new FormControl(''),
        });
    }

    constructor(
        public id?: number,
        public expert?: Expert,
    ) { }
}